/**
 * Valid system types where components need to determine what environment they are being used in
 *
 * @readonly
 * @enum {SystemType}
 */
export const ProviderVariantType = {
    PASSPORT_PROVIDERS: 1,
    EHCP_SCHOOLS: 2
}

